export default "__VITE_ASSET__72cde810__"